import axios from "axios";

const useAPI = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  return instance;
};

export default useAPI;
